import { Component, OnInit, Input, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IActivatedOrderVoucherDetails } from '@shared/state';
import { Controllers } from '@shared/core';
import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-order-summary',
    templateUrl: './order-summary.shared.component.html',
    styleUrls: ['./order-summary.shared.component.scss']
})
export class OrderSummaryComponent implements OnInit {
    @Input() public maxOnScreenHeight: string = null;

    @Input() public summary: OLO.Ordering.IOrderSummary = {};
    @Input() public voucher: IActivatedOrderVoucherDetails;
    @Input() public loading: boolean = false;
    @Input() public paidWith: string = null;

    @Input() public inverted: boolean = false; /* Consumer -> shared.loader */
    @Input() public color: string = null; /* Consumer -> shared.loader */
    @Input() public thickness: number = 2; /* Consumer -> shared.loader */

    public hasActiveVoucher$: Observable<boolean>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.hasActiveVoucher$ = this.controllers.onlineOrders.hasActiveVouchers$();
    }
}
